export const ResetForm={
  "info": "This option will reset all form fields to their default values. The values in your form fields will be lost. Are you sure you want to continue?",
  "DoNotAskAgain": "Don't ask again"
}